import type { ElementType, HTMLAttributes, ReactNode } from 'react';
import styles from './Micro.module.css';

type MicroProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  children: ReactNode;
};

/**
 * Uppercase micro-caption. 10px DM Sans 500, wide tracking, --ink-500.
 * Used throughout the mockups for kickers, meta labels, tiny hints.
 *
 * The `as` prop lets callers choose the DOM element (span / div / p / label).
 * Defaults to span so inline use is safe.
 */
export function Micro({ as: Tag = 'span', className, children, ...rest }: MicroProps) {
  return (
    <Tag className={[styles.micro, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </Tag>
  );
}
